import { render, staticRenderFns } from "./ClosedRents.vue?vue&type=template&id=5e271628&"
import script from "./ClosedRents.vue?vue&type=script&lang=js&"
export * from "./ClosedRents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports